<template>
  <div :style=computedStyles>
    <a :href="blok.link" :target="blok.new_tab ? '_blank': '_self'"
    class="blog-button bg-accent hover:bg-accent/90 !text-white !no-underline rounded-xl text-xs p-2.5">
      {{ blok.text }}
    </a>
  </div>
</template>

<script>
export default {
  name: "blog-cta-button",
  props: ["blok"],
  computed: {
    computedStyles() {
      return {
        textAlign: this.blok.alignment || "left",
        margin: "2rem 0"
      }
    },
  }
}
</script>
